import React from "react";

export const ActionCard = ({ onOpenModal }) => {
	const handleOpenModal = () => {
		onOpenModal(true);
	};

	return (
		<div className="w-full p-4 text-center bg-white border border-gray-200 rounded-lg shadow-sm sm:p-8 dark:bg-gray-800 dark:border-gray-700">
			<h5 className="mb-2 text-3xl font-bold text-gray-900 dark:text-white">Whether releasing independently or signing with a label...</h5>
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				Use Releases to track release dates and to stay on top of action items. Know when to start <br />
				marketing to your fans. Follow through on all your to-dos (like sending masters <br />
				to the label, logging the release in your PRO, SoundExchange, etc.)
			</p>
			<div className="items-center justify-center space-y-4 sm:flex sm:space-y-0 sm:space-x-4 rtl:space-x-reverse">
				<button
					onClick={handleOpenModal}
					type="button"
					className="border text-sky-500 hover:text-cyan-700 border-sky-500 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
					Add Your First Release
				</button>
			</div>
			<br />
			<p className="mb-5 text-base text-gray-500 sm:text-lg dark:text-gray-400">
				<span className="text-transparent font-bold bg-clip-text bg-gradient-to-r to-sky-500 from-cyan-700">PRO TIP</span>: When viewing a
				song in your catalog, you'll find a Release button there too. <br />
				Use that button to save some extra clicks!
			</p>
		</div>
	);
};
